import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    initialize() {
        this.sidebarContainer = this.element.querySelector("div");
        this.sidebarHeight = this.sidebarContainer.offsetHeight;     
        this.footer = document.querySelector('footer');
        document.addEventListener('scroll', this.handleScroll.bind(this)); 
    }

    handleScroll() {
        const sidebar = this.element;

        const scrollTop = window.pageYOffset;

        if (scrollTop + this.sidebarHeight >= this.footer.offsetTop) {
            this.sidebarContainer.classList.remove("md:sticky")
            this.sidebarContainer.classList.remove('md:top-[6rem]');
            this.sidebarContainer.classList.add('relative');
            sidebar.classList.add('flex');
            sidebar.classList.add('items-end');
        } else {
            this.sidebarContainer.classList.add("md:sticky")
            this.sidebarContainer.classList.add('md:top-[6rem]');
            this.sidebarContainer.classList.remove('relative');
            sidebar.classList.remove('flex');
            sidebar.classList.remove('items-end');
        }
    }
}